import { createRouter, createWebHashHistory, RouteRecordRaw } from "vue-router";
import store from "@/store/index";
//进度条
import NProgress from 'nprogress' ;
import 'nprogress/nprogress.css';

const routes: Array<RouteRecordRaw> = [
    {
        path: "/login",
        name: "login",
        component: () => import("@/views/login/login.vue"),
        meta: {
            // requiresAuth: true,
            name: "登录",
        },
    },

];

const router = createRouter({
    history: createWebHashHistory(),
    routes,
});

router.beforeEach((to: any, from: any, next: any) => {
    NProgress.start();
    //未登陆
     if (!window.localStorage.getItem("token") && to.path !== "/login") {
        return next({ path: "/login" });
    };
    //已登陆
    if(window.localStorage.getItem("token")&&to.path == "/login") return next({ path: "/" });
   //重新加载动态路由
    if (!store.state.permissionList&&to.path!='/login') {
        // router.removeRoute('router');
        return store.dispatch("FETCH_PERMISSION").then(() => {
            next({ ...to, replace: true });
        });
    } else {
        next();
    }
});

router.afterEach((to: any, from: any, next: any) => {
    NProgress.done();
    try {
        //设置标题
        if (to.meta.name) {
            document.title = to.meta.name;
        }
    } catch (err) {}
    let routerList = to.matched;
    //顶部面包屑
    store.commit("setCrumbList", routerList);
    //目前左边导航选中的active
    store.commit("SET_CURRENT_MENU", to.name);
});
/* 固定的路由 */
/*
    meta:{
        name:侧边栏名字,
        icon:侧边栏图标,
        hide:是否在侧边栏隐藏
    }
*/
export const DynamicRoutes = [
    {
        path: "",
        component:  () => import("@/components/nav/nav.vue"),
        name: "container",
        meta: {
            name: "主页",
            icon: "icon-fangzi",
        },
        children: [
            {
                path: "teaIndex",
                component: () => import("@/views/home/index.vue"),
                name: "teaIndex",
                meta: {
                    name: "主页",
                    hasMenu: false
                }
            }
        ]

    }
]

export const detailsRouter = [
    {
        path: "recordedBroadcast",
        component: () => import("@/views/recorded_broadcast/index.vue"),
        name: "recordedBroadcast",
        meta: {
            name: "录播功能页",
            hasMenu: false
        }
    },
    {
        path: "searchList",
        component: () => import("@/views/search/index.vue"),
        name: "searchList",
        meta: {
            name: "搜索列表页",
            hasMenu: false
        },
    },
    {
        path: "recordDetails",
        component: () => import("@/views/recorded_broadcast/recordDetails.vue"),
        name: "recordDetails",
        meta: {
            name: "录播详情页",
            hasMenu: false
        },
    },
    {
        path: "databank",
        component: () => import("@/views/databank/index.vue"),
        name: "databank",
        meta: {
            name: "资料库列表",
            hasMenu: false
        },
    },
    {
        path: "myCollect",
        component: () => import("@/views/collect/index.vue"),
        name: "myCollect",
        meta: {
            name: "个人中心",
            hasMenu: false
        }
    }
]

export default router;
